import type { Ubo, UboGround, UboInput } from 'generated/gql';

export const mapUboToUboInput = (ubo: Partial<Ubo>): UboInput => ({
  ground: ubo.ground as UboGround,
  naturalPersonId: ubo.naturalPerson?.id || '',
  ownershipRange: ubo.ownershipRange,
});
